"use client";

import { useEffect, useState } from "react";

/** Evita que los controles fijos cubran las ligas del pie de página. */
export function usePieVisible() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const pie = document.querySelector("footer.pie");
    if (!pie) return;
    const observador = new IntersectionObserver(([entrada]) => setVisible(entrada.isIntersecting));
    observador.observe(pie);
    return () => observador.disconnect();
  }, []);

  return visible;
}
